<template>
  <layout-page name="login" wide bg-image centered box>
    <login-box />
  </layout-page>
</template>

<script>
import LoginBox from "@/components/Login/Box.vue";
import store from "../store";

export default {
  name: "LoginPage",
  components: { LoginBox },
  beforeRouteEnter(to, from, next) {
    if (!!store.state.user && !to.query.logout) {
      next("/app");
      return;
    }

    if (to.query.token) {
      store.commit("token", to.query.token);
      store.dispatch("loadUser").then(() => next("/app"));
      return;
    }

    next();
  },
  mounted() {
    if (this.$route.query?.error) {
      switch (this.$route.query.error) {
        case "google":
          this.$store.commit("addNotification", {
            content: this.$t("components.login.box.google_oauth_error"),
            title: this.$t("components.login.box.login_error"),
            variant: "danger",
            type: "login",
          });
      }
    }
  },
};
</script>

<style lang="scss"></style>
